import React, {useEffect, useState} from "react"

import "./Shop.css"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import {getDateStr, getDateString, retrieveData, sendRequest} from "../../common";
import {useNavigate} from "react-router-dom";

function Qualification() {

	const navigate = useNavigate()

	const [certificates, setCertificates] = useState([])
	const [user, setUser] = useState()
	const [certificateType, setCertificateType] = useState()
	const [date, setDate] = useState()
	const [completeNumber, setCompleteNumber] = useState()
	const [certNumber, setCertNumber] = useState()
	const [certificateTypes, setCertificateTypes] = useState([])

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			if (!user || !user?.isExpert) {
				alert('전문가 회원만 볼 수 있습니다.')
				navigate(-1)
				return
			}
		})
		getCertificates()
		getCertificateTypes()
	}, [])

	const getCertificateTypes = () => {
		sendRequest('accounts/certificate-type2/', 'GET', null, data => {
			console.log(data); // 실제로 무엇이 오는지 확인
			setCertificateTypes(data)
		})
	}

	let isLoading = false

	const saveCertificate = (e) => {
		e.preventDefault()

		if (!certificateType || !date || !completeNumber?.length || !certNumber?.length) {
			alert('4가지를 모두 입력해주세요.')
			return
		}

		if (isLoading) return
		isLoading = true

		alert('업데이트 요청 되었습니다.')
		sendRequest('accounts/certificate/', 'POST', {
			certificateType,
			date,
			completeNumber,
			certNumber
		}, data => {
			getCertificates()
			setCertificateType()
			setDate(null)
			setCompleteNumber('')
			setCertNumber('')
			isLoading = false
		}, (data, code) => {
			isLoading = false
		})
	}

	const getCertificates = () => {
		sendRequest('accounts/certificate/?isMy=1', 'GET', null, data => {
			setCertificates(data)
		})
	}

	return (
		<>
			<Nav user={user}/>
			<SubBanner title={"구매자격"} firstText={"온라인 구매"} lastText={"자격을 확인해보세요."} />
			<div className="container">
				<div className="cardContent qualification">
					<section>
						<h4>구매자격 안내</h4>
						<div className="infoCard">
							<div style={{width: "100%"}}>
								<h6>
									<span>PTS 심리유형 탐색지, PTS 도형심리 탐색지</span> 온라인 구매
								</h6>
								<ul>
									<li>강사 과정 수료</li>
									<li>상담사 과정 수료</li>
									<li>FE 자격자</li>
								</ul>
							</div>
							{/* <div>
								<h6>
									<span>PTS 도형심리 탐색지</span> 구매
								</h6>
								<ul>
									<li>PTS 심화과정 + 도형심리 과정 수료</li>
									<li>FE 자격자 + 도형심리 과정 수료</li>
								</ul>
							</div> */}
						</div>
					</section>
					<section>
						<h4>내 정보</h4>
						<ul className="infoList">
							<li>
								<h5>이름</h5> <span>{user?.name?.slice(0, 1) + '*' + user?.name?.slice(2)}</span>
							</li>
							<li>
								<h5>연락처</h5> <span>{user?.phone}</span>
							</li>
							<li>
								<h5>이메일</h5> <span>{user?.email}</span>
							</li>
							<li>
								<h5>주소</h5> <span>{user?.address}</span>
							</li>
						</ul>
					</section>
					<section>
						<h4>내 구매자격</h4>
						<form name="update">
							<ul className="updateForm">
								<li className="formWrap">
									<div className="formItem">
										<div className="formHead">
											<span className="formName">수료과정</span>
										</div>
									</div>
									<div className="formItem">
										<div className="formBody">
											<span>
												<select name="course" required onChange={e => setCertificateType(e.target.value)}>
													<option defaultValue="" disabled selected>
														수료과정을 선택하세요
													</option>
													{certificateTypes?.map((item, index) => {
														return (
															<option value={item?.id}>{item?.name}</option>
														)
													})}
												</select>
											</span>
										</div>
									</div>
								</li>
								<li className="formWrap">
									<div className="formItem">
										<div className="formHead">
											<span className="formName">수료일</span>
										</div>
									</div>
									<div className="formItem">
										<div className="formBody">
											<span>
												<input type="date" name="date" max={getDateStr(new Date())} required onChange={e => setDate(e.target.value)} />
											</span>
										</div>
									</div>
								</li>
								<li className="formWrap">
									<div className="formItem">
										<div className="formHead">
											<span className="formName">수료번호</span>
										</div>
									</div>
									<div className="formItem">
										<div className="formBody">
											<span>
												<input type="text" name="text" placeholder="수료번호를 입력하세요" required onChange={e => setCompleteNumber(e.target.value)}/>
											</span>
										</div>
									</div>
								</li>
								<li className="formWrap">
									<div className="formItem">
										<div className="formHead">
											<span className="formName">자격번호</span>
										</div>
									</div>
									<div className="formItem">
										<div className="formBody">
											<span>
												<input type="text" name="text" placeholder="자격번호를 입력하세요" required onChange={e => setCertNumber(e.target.value)} />
											</span>
										</div>
									</div>
								</li>
								<li className="formWrap">
									<div className="formItem">
										<div className="formHead">
											<span className="formName">구매자격</span>
										</div>
									</div>
									<div className="formItem">
										<div className="formBody">
											<button type="button" onClick={saveCertificate}>업데이트 요청</button>
										</div>
									</div>
								</li>
							</ul>
						</form>
						<div className="shopTableWrap">
							<table className="shopTable">
								<colgroup>
									<col width="20%" />
								</colgroup>
								<thead>
									<tr>
										<th>수료과정</th>
										<th>수료일</th>
										<th>수료번호</th>
										<th>자격번호</th>
										<th>최종 업데이트</th>
										<th>승인 여부</th>
									</tr>
								</thead>
								<tbody>
									{certificates?.map((item, index) => {
										return (
											<tr>
												<td>{item?.certificateType?.name}</td>
												<td>{getDateString(new Date(item?.date))}</td>
												<td>{item?.completeNumber}</td>
												<td>{item?.certNumber}</td>
												<td className="blue">{item?.confirmDate ? getDateString(new Date(item?.confirmDate)) : '-'}</td>
												<td>{item?.isConfirm ? '승인' : '미승인'}</td>
											</tr>
										)
									})}

								</tbody>
							</table>
						</div>
					</section>
				</div>
			</div>

			<Footer />
		</>
	)
}

export default Qualification
